import { For, type VoidComponent } from "solid-js";
import { Icon } from "../../../../components/icon/Icon";
import Text from "../../../../components/text/Text";
import { GroupsPopover } from "./GroupsPopover";
import type { PermissionInfo } from "../../../../utils/roleUtil";

export const PermissionList: VoidComponent<{ permissions: PermissionInfo[] }> = (props) => (
  <div class="grid grid-cols-2 gap-x-10 gap-y-6">
    <For each={props.permissions}>
      {(entry) => (
        <div class="flex gap-2">
          <Icon name="check" size="md" type="solid" class="mt-0.5 shrink-0 icon-status-informative" />
          <div class="flex flex-col items-start">
            <span class="inline-flex flex-wrap items-center gap-1">
              <Text as="h3" text={entry.title} class="text-base-medium text-nowrap text-primary" />
              <GroupsPopover sections={[{ groups: entry.groups }]} />
            </span>
            <Text as="p" text={entry.description} class="text-base-regular text-secondary" />
          </div>
        </div>
      )}
    </For>
  </div>
);
